import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

/** For ACADEMIC_ADMIN: list institutions where the current user is an admin. */
export async function getMyInstitutions() {
  return axios
    .get(`${BASE_URL}/api/institutions/mine`)
    .then((response) => response.data);
}

/** For ACADEMIC_ADMIN: create a new institution and link current user as admin. */
export async function createMyInstitution(payload) {
  return axios
    .post(`${BASE_URL}/api/institutions/mine`, payload)
    .then((response) => response.data);
}

export async function updateMyInstitutionStatus(institutionId, active) {
  return axios
    .put(`${BASE_URL}/api/institutions/mine/${institutionId}/status`, { active })
    .then((response) => response.data);
}

export async function deleteMyInstitution(institutionId) {
  return axios.delete(`${BASE_URL}/api/institutions/mine/${institutionId}`);
}

export async function getInstitutions() {
  return axios
    .get(`${BASE_URL}/api/institutions`)
    .then((response) => response.data);
}

export async function createInstitution(payload) {
  return axios
    .post(`${BASE_URL}/api/institutions`, payload)
    .then((response) => response.data);
}

export async function updateInstitution(institutionId, payload) {
  return axios
    .put(`${BASE_URL}/api/institutions/${institutionId}`, payload)
    .then((response) => response.data);
}

export async function getInstitutionAdmins(institutionId) {
  return axios
    .get(`${BASE_URL}/api/institutions/${institutionId}/admins`)
    .then((response) => response.data);
}

export async function addInstitutionAdmin(institutionId, email) {
  return axios
    .post(`${BASE_URL}/api/institutions/${institutionId}/admins`, { email })
    .then((response) => response.data);
}

export async function updateInstitutionAdminStatus(institutionId, adminId, active) {
  return axios
    .put(`${BASE_URL}/api/institutions/${institutionId}/admins/${adminId}`, {
      active,
    })
    .then((response) => response.data);
}

export async function deleteInstitutionAdmin(institutionId, adminId) {
  return axios.delete(
    `${BASE_URL}/api/institutions/${institutionId}/admins/${adminId}`
  );
}
